import FullScreenToggle from './FullScreenToggle';

export default FullScreenToggle;